// -----------------------------------------------------------------------------
// This files contains the types of result managed by the switch in data
// -----------------------------------------------------------------------------

export const RESULT_TYPES = {
    TIME: { label: 'Time' },
    ENERGY: { label: 'Energy' },
} as const;

export type ResultKind = 'TIME' | 'ENERGY';

export const isTimeLabel = (s?: string) => (s ?? '').trim().toLowerCase() === 'time';

export const isEnergyLabel = (s?: string) => (s ?? '').trim().toLowerCase() === 'energy';

/** Find the real array index for TIME in layer.results (or -1). */
export const findTimeIndex = (results: any[] | undefined) =>
    Array.isArray(results) ? results.findIndex((r) => isTimeLabel(r?.resultLabel)) : -1;

/** Find the real array index for ENERGY in layer.results (or -1). */
export const findEnergyIndex = (results: any[] | undefined) =>
    Array.isArray(results) ? results.findIndex((r) => isEnergyLabel(r?.resultLabel)) : -1;
